import { useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../lib/supabase";

const css = `
  .auth-page { min-height:100vh; display:flex; align-items:center; justify-content:center; padding:24px; }
  .auth-card { background:var(--card); border:1px solid var(--border); border-radius:20px; padding:40px; max-width:420px; width:100%; }
  .auth-logo { font-family:var(--head); font-size:26px; font-weight:800; letter-spacing:2px; margin-bottom:24px; }
  .auth-logo span { color:var(--blue); }
  .auth-title { font-family:var(--head); font-size:22px; font-weight:800; letter-spacing:1px; margin-bottom:6px; }
  .auth-sub   { color:var(--muted); font-size:14px; margin-bottom:24px; line-height:1.5; }
  .auth-error { color:var(--danger); font-size:13px; margin-bottom:12px; text-align:center; }
  .auth-footer { text-align:center; margin-top:18px; color:var(--muted); font-size:14px; }
  .auth-footer a { color:var(--blue); font-weight:500; }
`;

export default function ForgotPassword() {
  const [email, setEmail]     = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent]       = useState(false);
  const [error, setError]     = useState(null);

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true); setError(null);
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    if (error) { setError(error.message); setLoading(false); return; }
    setSent(true);
    setLoading(false);
  };

  return (
    <>
      <style>{css}</style>
      <div className="auth-page">
        <div className="auth-card fade-in">
          <div className="auth-logo">NEO<span> DETAIL</span></div>

          {sent ? (
            <>
              <div style={{ textAlign:"center", padding:"10px 0 20px" }}>
                <div style={{ fontSize:52, marginBottom:16 }}>📧</div>
                <div className="auth-title">CHECK YOUR EMAIL</div>
                <div className="auth-sub">
                  We sent a password reset link to <strong style={{ color:"var(--teal)" }}>{email}</strong>.<br />
                  Click the link to set a new password.
                </div>
                <div style={{ color:"var(--muted)", fontSize:13 }}>
                  Didn't get it? Check your spam folder or{" "}
                  <button style={{ background:"none", border:"none", color:"var(--blue)", cursor:"pointer", fontSize:13, fontWeight:500, padding:0 }}
                    onClick={() => setSent(false)}>
                    try again
                  </button>.
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="auth-title">FORGOT PASSWORD</div>
              <div className="auth-sub">Enter your email and we'll send you a reset link.</div>
              <form onSubmit={handleSubmit}>
                <div className="form-group" style={{ marginBottom:20 }}>
                  <label>Email</label>
                  <input type="email" placeholder="you@email.com" value={email}
                    onChange={e => setEmail(e.target.value)} required autoFocus />
                </div>
                {error && <div className="auth-error">{error}</div>}
                <button className="btn-primary full" type="submit" disabled={loading}>
                  {loading ? <><span className="spinner" /> Sending...</> : "Send Reset Link →"}
                </button>
              </form>
            </>
          )}

          <div className="auth-footer">
            <Link to="/login">← Back to Sign In</Link>
          </div>
        </div>
      </div>
    </>
  );
}
